import { MemeTemplate } from "types/meme";
import { useMemesList } from "./useMemesList";
import { Loader } from "components/common/Icons/Loader/Loader";
import { MemesSearchBox } from "./MemesSearchBox/MemesSearchBox";
import translatedRoutedSlugs from "translatedRouteSlugs";
import { useRouter } from "next/router";
import { MouseEvent } from "react";

export const MemesList = () => {
    const {
        memes,
        isFetching,
        search,
        handleSearch,
        isFetchingNewPage,
        handleClickMeme,
        handleScroll,
        selectedMemeId,
    } = useMemesList();

    return (
        <div>
            <div className="px-6">
                <MemesSearchBox search={search} handleSearch={handleSearch} />
            </div>
            {isFetching && (
                <div className="flex items-center justify-center py-6">
                    <Loader className="stroke-[var(--dark-gray)]" width={30} height={30} />
                </div>
            )}
            <div
                className="grid grid-cols-3 gap-2 my-6 px-3 mx-3 max-h-[410px] scroll overscroll-none"
                onScroll={handleScroll}
            >
                {!isFetching &&
                    memes.map((meme) => (
                        <Meme key={meme.id} meme={meme} handleClick={handleClickMeme} selectedMemeId={selectedMemeId} />
                    ))}
                {isFetchingNewPage && (
                    <div className="flex items-center justify-center col-span-3 py-2 underline cursor-pointer text-irBlue-600">
                        <Loader className="stroke-[var(--dark-gray)]" width={20} height={20} />
                    </div>
                )}
            </div>
        </div>
    );
};

interface MemeProps {
    meme: MemeTemplate;
    handleClick: (meme: MemeTemplate, e?: MouseEvent) => void;
    selectedMemeId?: string;
}

const Meme = ({ meme, handleClick, selectedMemeId }: MemeProps) => {
    const { locale } = useRouter();
    const isSelected = meme.id === selectedMemeId;
    return (
        <a
            tabIndex={0}
            className={`${
                isSelected ? "border-4 border-irBlue-400" : "focus:outline-4"
            } focus:outline-irBlue-200 flex items-center justify-center rounded-md`}
            onClick={(e) => handleClick(meme, e)}
            href={`/${locale === "en" ? "": `${locale}/`}${translatedRoutedSlugs["/meme-generator/edit/:slug"][
                (locale as keyof (typeof translatedRoutedSlugs)["/meme-generator/edit/:slug"]) || "en"
            ].replace(":slug", meme.slugKey)}`}
        >
            <img src={meme.thumbnailUrl} alt={meme.title} className="w-full" />
        </a>
    );
};
